<template>
    <div class="config-margin-one">
        <div class="config-margin-card rounder-8 mb-4">
            <div class="product-info-header">
                <span class="product-sku-badge">{{ propHead.row.sku }}</span>
                <span class="product-name-text">{{ propHead.row.long_name }}</span>
            </div>
            <!-- Inputs de margen -->
            <div class="row g-3 mb-4">
                <div class="col-4">
                    <label class="form-label fw-600 size-13 text-secondary mb-2">{{(shouldShowAsRecommender().serviceTypeRecommender || shouldShowAsRecommender().neitherService)  ? 'MARGEN' : 'MARKUP'}} MÍNIMO</label>
                    <div class="input-group">
                        <input 
                            type="number" 
                            class="form-control fw-600 size-16" 
                            v-model.number="marginMin"
                            min="0" 
                            max="100" 
                            step="0.1"
                            :class="{'is-invalid': marginMin > marginMax}"
                        />
                        <span class="input-group-text bg-light border-start-0 text-secondary fw-500">%</span>
                    </div>
                    <small class="text-secondary size-12 mt-2 d-block">Bajo este valor → alerta crítica</small>
                </div>
                <div class="col-4">
                    <label class="form-label fw-600 size-13 text-secondary mb-2">{{(shouldShowAsRecommender().serviceTypeRecommender || shouldShowAsRecommender().neitherService)  ? 'MARGEN' : 'MARKUP'}} OBJETIVO</label>
                    <div class="input-group">
                        <input 
                            type="number" 
                            class="form-control fw-600 size-16" 
                            v-model.number="marginObjective"
                            min="0" 
                            max="100" 
                            step="0.1"
                        />
                        <span class="input-group-text bg-light border-start-0 text-secondary fw-500">%</span>
                    </div>
                    <small class="text-secondary size-12 mt-2 d-block">El motor apunta a este margen</small>
                </div>
                <div class="col-4">
                    <label class="form-label fw-600 size-13 text-secondary mb-2">{{(shouldShowAsRecommender().serviceTypeRecommender || shouldShowAsRecommender().neitherService)  ? 'MARGEN' : 'MARKUP'}} MÁXIMO</label>
                    <div class="input-group">
                        <input 
                            type="number" 
                            class="form-control fw-600 size-16" 
                            v-model.number="marginMax"
                            min="0" 
                            max="100" 
                            step="0.1"
                            :class="{'is-invalid': marginMin > marginMax}"
                        />
                        <span class="input-group-text bg-light border-start-0 text-secondary fw-500">%</span>
                    </div>
                    <small class="text-secondary size-12 mt-2 d-block">Sobre este → revisión de competitividad</small>
                </div>
            </div>
        </div>

        <!-- Margen actual del producto -->
        <div class="config-margin-current p-3 bg-white rounder-8 border mb-4" v-if="propHead.row">
            <div class="d-flex justify-content-between align-items-center">
                <div>
                    <span class="size-13 text-secondary">{{(shouldShowAsRecommender().serviceTypeRecommender || shouldShowAsRecommender().neitherService)  ? 'MARGEN' : 'MARKUP'}}  actual del producto</span>
                    <h4 class="fw-600 size-20 mb-0 mt-1" :class="getMarginStatusClass()">
                        {{ propHead.row.margin_percent || '0.00 %' }}
                    </h4>
                </div>
                <span class="badge size-13 px-3 py-2 fw-500" :class="getConfigStatusBadgeClass()">
                    {{ getConfigStatusLabel() }}
                </span>
            </div>
        </div>

        <!-- Botones de acción -->
        <div class="d-flex justify-content-end gap-2">
            <button class="btn btn-success fw-400 px-4" @click="saveMargin" :disabled="saving">
                <span v-if="saving">Guardando...</span>
                <span v-else>Guardar</span>
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions,mapGetters } from 'vuex';
import {  shouldShowAsRecommender } from '../../../../../utils/servicesValidation.js'
export default {
    name: 'config-margin-one',
    props: {
        propHead: {
            type: Object,
            default: () => ({})
        },
        activeServiceId: {
            type: Number,
            default: 5
        }
    },
    data() {
        return {
            marginMin: 0,
            marginObjective: 0,
            marginMax: 0,
            saving: false,
        };
    },
    computed: {
        ...mapGetters([
            "authentication_user",
        ]),
    },
    created() {
        this.loadCurrentValues();
    },
    methods: {
        ...mapActions(['update']),
        loadCurrentValues() {
            const row = this.propHead.row;
            if (row) {
                this.marginMin = parseFloat(row.margin_min) * 100 || 0;
                this.marginObjective = parseFloat(row.margin_objective) * 100 || 0;
                this.marginMax = parseFloat(row.margin_max) * 100 || 0;
            }
        },
        getMarginStatusClass() {
            const row = this.propHead.row;
            if (!row) return '';
            const status = row.margin_status;
            if (status === 'ok') return 'text-success';
            if (status === 'bajo') return 'text-danger';
            if (status === 'alto') return 'text-warning';
            return 'text-secondary';
        },
        getMarginBadgeClass() {
            const row = this.propHead.row;
            if (!row) return 'bg-light text-secondary';
            const status = row.margin_status;
            if (status === 'ok') return 'bg-success-subtle text-success';
            if (status === 'bajo') return 'bg-danger-subtle text-danger';
            if (status === 'alto') return 'bg-warning-subtle text-warning';
            return 'bg-light text-secondary';
        },
        getMarginStatusText() {
            const row = this.propHead.row;
            if (!row) return 'N/A';
            const status = row.margin_status;
            if (status === 'ok') return '✓ Normal';
            if (status === 'bajo') return '⚠ Fuera de rango|';
            if (status === 'alto') return ' Fuera de rango';
            return 'N/A';
        },
        getConfigStatusBadgeClass() {
            const status = this.propHead.row?.margin_config_status;
            if (status === 'normal') return 'bg-success-subtle text-success';
            if (status === 'fuera_de_rango') return 'bg-danger-subtle text-danger';
            return 'bg-light text-secondary';
        },
        getConfigStatusLabel() {
            const status = this.propHead.row?.margin_config_status;
            if (status === 'normal') return 'Normal';
            if (status === 'fuera_de_rango') return 'Fuera de rango';
            if (status === 'por_configurar') return 'Por configurar';
            return '—';
        },
        saveMargin() {
            if (this.marginMin > this.marginMax) {
                this.$notification.error('El margen mínimo debe ser menor o igual al máximo.', { timer: 5, showCloseIcn: true });
                return;
            }
            this.saving = true;
            const data = {
                id: this.propHead.row.id,
                margin_min: this.marginMin / 100,
                margin_objective: this.marginObjective / 100,
                margin_max: this.marginMax / 100,
            };
            this.update({
                url: `/api/products/config_margin/update/`,
                params: data,
            }).then(() => {
                this.saving = false;
                this.$emit('refrest');
                this.$notification.success('Márgenes actualizados correctamente.', { timer: 5, showCloseIcn: true });
            }).catch((error) => {
                this.saving = false;
                if (error.status == 400) {
                    this.$notification.error(error.data.message || 'Error al guardar los márgenes.', { timer: 5, showCloseIcn: true });
                } else {
                    this.$notification.error('Error al guardar los márgenes.', { timer: 5, showCloseIcn: true });
                }
            });
        },
        /**
         * Verifica si debe mostrar como recomendador (para usar en template)
         */
        shouldShowAsRecommender(user = null) {
            return shouldShowAsRecommender(user || this.authentication_user, this.activeServiceId);
        }
    }
};
</script>

<style scoped>
.config-margin-card {
    background: #ffffff;
}

.product-info-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 0;
    margin-bottom: 16px;
}

.product-sku-badge {
    display: inline-block;
    background: #f3f4f6;
    color: #6b7280;
    font-size: 0.75rem;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 4px;
    white-space: nowrap;
}

.product-name-text {
    font-size: 0.9rem;
    font-weight: 500;
    color: #374151;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.input-group-text {
    background-color: #f8f9fa !important;
    border-color: #dee2e6 !important;
    font-size: 14px;
}

.form-control:focus {
    border-color: #1AA179;
    box-shadow: 0 0 0 0.2rem rgba(26, 161, 121, 0.25);
}

.form-control.is-invalid {
    border-color: #dc3545;
}

.form-control.is-invalid:focus {
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}

.range-label-item {
    transform: translateX(0);
}

.range-bar-wrapper {
    background: transparent;
}

.bg-success-subtle {
    background-color: #d1fae5 !important;
}

.bg-danger-subtle {
    background-color: #fee2e2 !important;
}

.bg-warning-subtle {
    background-color: #fef3c7 !important;
}

.btn-success {
    background-color: #1AA179 !important;
    border-color: #1AA179 !important;
}

.btn-success:hover:not(:disabled) {
    background-color: #158a65 !important;
    border-color: #158a65 !important;
}

.btn-success:disabled {
    opacity: 0.65;
}
</style>
